import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import '@fortawesome/fontawesome-pro'
import '@fortawesome/free-solid-svg-icons'
import '@fortawesome/fontawesome-pro/css/all.css'
import './assets/styles/theme/display.css'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import './assets/styles/main.scss'
import './assets/styles/element-variables.scss'
import 'material-design-icons/iconfont/material-icons.css'
import ptBr from 'vee-validate/dist/locale/pt_BR.json';
import veeValidate from '@/utils/veeValidate';
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate';

import Element, {MessageBox} from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pt-br'
import VueTheMask from 'vue-the-mask'
import VueToastr from '@deveodk/vue-toastr'
import messages from '@/constants/messages'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false

Vue.use(VueToastr)
Vue.use(Element, { locale })
Vue.use(VueTheMask)
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
localize('pt-BR', ptBr);

veeValidate();

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$messages = messages
Vue.prototype.$confirm = MessageBox.confirm

Vue.filter('timestamp', (value) => {
  if (value) {
    const date = new Date(value);

    const day = '0' + date.getUTCDate();
    const month = '0' + (date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();

    return `${day.substr(-2)}/${month.substr(-2)}/${year}`;
  }
})

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
